import {put, takeEvery} from "redux-saga/effects";

function* resetSteps() {
  try {
    yield put({type: 'SAVE.RESET_STEPS.SUCCESS'});
  } catch (error) {
    yield put({type: 'SAVE.RESET_STEPS.FAILURE', error});
  }
}

function* setSteps(action) {
  try {
    yield put({type: 'SAVE.SET_STEPS.SUCCESS', params:action.params});
  } catch (error) {
    yield put({type: 'SAVE.SET_STEPS.FAILURE', error});
  }
}

function* setNextStep() {
  try {
    yield put({type: 'SAVE.SET_NEXT_STEP.SUCCESS'});
  } catch (error) {
    yield put({type: 'SAVE.SET_NEXT_STEP.FAILURE', error});
  }
}

function* setPrevioustStep() {
  try {
    yield put({type: 'SAVE.SET_PREVIOUS_STEP.SUCCESS'});
  } catch (error) {
    yield put({type: 'SAVE.SET_PREVIOUS_STEP.FAILURE', error});
  }
}

export function* watchSteps() {
  yield takeEvery('SAVE.RESET_STEPS.REQUEST', resetSteps);
  yield takeEvery('SAVE.SET_STEPS.REQUEST', setSteps);
  yield takeEvery('SAVE.SET_NEXT_STEP.REQUEST', setNextStep);
  yield takeEvery('SAVE.SET_PREVIOUS_STEP.REQUEST', setPrevioustStep);
}






// WEBPACK FOOTER //
// ./src/sagas/stepper.js